import React from 'react';
import { createPortal } from 'react-dom';
import AdminKbd from './AdminKbd';
import './AdminShortcutsSheet.css';

const SHORTCUT_ROWS = [
  { keys: ['/',], description: 'Focus the nearest admin search input' },
  { keys: ['Cmd', 'K'], description: 'Open the admin spotlight on macOS' },
  { keys: ['Ctrl', 'K'], description: 'Open the admin spotlight on Windows/Linux' },
  { keys: ['G', '1-5'], description: 'Jump to Review, Audit, Forge, Lab, or Ops' },
  { keys: ['J'], description: 'Select the next row in keyboard-enabled admin tables' },
  { keys: ['K'], description: 'Select the previous row in keyboard-enabled admin tables' },
  { keys: ['Enter'], description: 'Open the selected row in a keyboard-enabled admin table' },
  { keys: ['?'], description: 'Open this shortcuts sheet' },
];

/**
 * @param {{
 *   open?: boolean,
 *   onClose?: (() => void) | null
 * }} props
 */
function AdminShortcutsSheet({ open = false, onClose = null }) {
  if (!open || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className="au-shortcuts-sheet au-scope" role="presentation">
      <button type="button" className="au-shortcuts-sheet__backdrop" aria-label="Close shortcuts sheet" onClick={onClose || undefined} />
      <aside className="au-shortcuts-sheet__panel" aria-label="Admin shortcuts">
        <div className="au-shortcuts-sheet__header">
          <div>
            <div className="au-shortcuts-sheet__eyebrow">Keyboard</div>
            <h2 className="au-shortcuts-sheet__title">Admin shortcuts</h2>
          </div>
          <button type="button" className="au-shortcuts-sheet__close" onClick={onClose || undefined}>
            Close
          </button>
        </div>
        <div className="au-shortcuts-sheet__rows">
          {SHORTCUT_ROWS.map((row) => (
            <div key={row.description} className="au-shortcuts-sheet__row">
              <div className="au-shortcuts-sheet__keys">
                {row.keys.map((key) => <AdminKbd key={key}>{key}</AdminKbd>)}
              </div>
              <p className="au-shortcuts-sheet__description">{row.description}</p>
            </div>
          ))}
        </div>
      </aside>
    </div>,
    document.body,
  );
}

export default AdminShortcutsSheet;
